// type: decorator

import { Nullable } from '@rotomeca/utils';
import { delegate } from '../utils/eventsFunctions';
import Log from '../utils/Log';

/**
 * Décorateur pour attacher automatiquement un écouteur d'événement.
 * La méthode décorée doit retourner la fonction de callback.
 *  @param eventName Nom de l'événement à écouter (ex: 'click')
 *  @param option Sélecteur CSS pour le délégateur (optionnel)
 */
export function Listen(
  eventName: string,
  { selector = null }: { selector?: Nullable<string> } = {},
) {
  return function (originalMethod: any, context: ClassMethodDecoratorContext) {
    if (context.kind !== 'method') {
      throw new Error('@Listen ne peut être utilisé que sur des méthodes.');
    }

    // On ajoute un initialiseur qui s'exécutera à la création de chaque instance
    context.addInitializer(function (this: any) {
      const handler = originalMethod.call(this);

      if (typeof handler === 'function') {
        const boundHandler = handler.bind(this);

        if (selector) delegate(this, eventName, selector, boundHandler);
        else this.addEventListener(eventName, boundHandler);
      } else {
        Log.warn(
          '@Listen',
          `La méthode "${String(context.name)}" n'a pas renvoyé de fonction pour l'événement "${eventName}".`,
        );
      }
    });
  };
}
